<template>
  
      <div class="column">
         <div style="margin: 6px 0;">
          <slot name="icon"></slot>
         </div>
        <h4 class="w400" style="line-height: 34px;"><slot name="title"></slot></h4>
        <p class="micro w350"><slot name="desc"></slot></p>
      </div>
  
</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({data() {return {}}});
</script>
